module.exports = __webpack_public_path__ + "files/2a927fb8b3695957684531b1b88a8cae.png";